import { MyTableComponent, Button } from "components"
import { Box } from "theme-ui"
import { useTranslation } from "react-i18next"

export const PtChain = () => {
 // language translator
 const { t } = useTranslation("translation")

 const data = [
  {
   info1: "Test",
   info2: "F2",
   info3: "",
  },
  {
   info1: "",
   info2: "",
   info3: "",
  },
 ]

 const columns = [
  { Header: t("designation"), accessor: "info1" },
  { Header: t("signalGroup"), accessor: "info2" },
  { Header: t("signalGroup"), accessor: "info3" },
  {
   Header: t("action"),
   Cell: ({ row }: any) => (
    <div className="flex">
     {row.original.info1 && row.original.info2 !== "" ? (
      <div className="flex">
       <div className="mr-2">
        <Button size={"tableSmallSize"} color={"darkBrown"}>
         {" "}
         {t("edit")}
        </Button>
       </div>
       <div>
        <Button size={"tableSmallSize"} color={"pink"}>
         {t("delete")}
        </Button>
       </div>
      </div>
     ) : (
      <div>
       <Button size={"tableSmallSize"} color={"blue"}>
        {t("add")}
       </Button>
      </div>
     )}
    </div>
   ),
  },
 ]

 return (
  <div className="w-full lg:w-[96%] mx-auto relative h-screen  md:h-screen lg:h-full pt-5">
   <div className="mb-4 Jakarta-font">
    <h1 className="font-bold text-xl">{t("publicTransportReportingRoutes")}</h1>
    <p className="text-sm pt-1">Hier können Sie die ÖPNV-Meldestrecken bearbeiten</p>
   </div>
   <div className="mb-4">
    <Box bg="highlight">
     <div className="py-3 px-3">
      <h1 className="Jakarta-font font-semibold text-lg">Testserver: Testanlage 01 Gera</h1>
     </div>
    </Box>

    {/* ====== TableComponent ====== */}
    <MyTableComponent fullHeight={true} columns={columns} data={data} paginate={false} />
   </div>

   <div className="mb-4">
    <Box bg="highlight">
     <div className="py-3 px-3">
      <h1 className="Jakarta-font font-semibold text-lg">Testserver: Testanlage 01 Gera</h1>
     </div>
    </Box>

    {/* ====== TableComponent ====== */}
    <MyTableComponent fullHeight={true} columns={columns} data={data} paginate={false} />
   </div>
  </div>
 )
}
